import styled from "styled-components";

export const Panel = styled.div`
  background-color: ${({ theme }) => theme.colors.color18};
  border-radius: 12px;
  box-shadow: -30px 30px 30px rgba(0, 0, 0, 0.16);
  margin-right: 15px;
  padding: 44px 30px;
  position: absolute;
  right: 0;
  top: 74px;
  width: 460px;
  z-index: 200;
`;

export const SettingsTitle = styled.h3`
  color: ${({ theme }) => theme.colors.color6};
  font-size: 30px;
  margin-bottom: 15px;
`;

export const Label = styled.div`
  color: ${({ theme }) => theme.colors.color21};
  font-size: 24px;
  font-weight: 700;
  padding-left: 8px;
  padding-top: 40px;
  width: 275px;
`;

export const FormElement = styled.div`
  display: flex;
  height: 110px;
  position: relative;

  &:before {
    border-bottom: 0.5px solid ${({ theme }) => theme.colors.color19};
    content: "";
    opacity: 0.4;
    position: absolute;
    width: 400px;
  }
`;

export const IconWrapper = styled.div`
  position: absolute;
  right: 28px;
  top: 52px;

  svg {
    path {
      fill: ${({ theme }) => theme.colors.color19};
    }
  }
`;

export const CheckboxWrapper = styled.div`
  align-items: center;
  display: flex;
  position: relative;
  width: 100%;
`;


export const CheckMark = styled.span`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.color25};
  height: 32px;
  position: absolute;
  right: 0;
  top: auto;
  width: 32px;
  z-index: 30;

  &:after {
    -ms-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    border: solid ${({ theme }) => theme.colors.color6};
    border-radius: 3px;
    border-width: 0 5px 5px 0;
    content: "";
    display: none;
    height: 17px;
    left: 10px;
    position: absolute;
    top: 5px;
    transform: rotate(45deg);
    width: 10px;
  }
`;

export const CheckBox = styled.input`
  cursor: pointer;
  height: 32px;
  opacity: 0;
  position: absolute;
  right: 0;
  top: auto;
  width: 32px;
  z-index: 50;

  &:checked ~ ${CheckMark}:after {
    display: block;
  }
`;
